/* @source catpaw @line_count 277 @branch feature/ai-92575103-202604091027 */
<template>
  <mtd-modal
    v-model="visible"
    :closable="!isForce"
    :mask-closable="false"
    :before-close="handleBeforeClose"
    width="700px"
    title="课程提醒"
    class="course-popup-dialog"
  >
    <div class="course-popup-content">
      <div class="course-popup-desc">
        <template v-if="overdueCount > 0">
          您有 <b>{{ overdueCount }}</b> 项学习任务未完成，需完成后才可使用系统，请尽快完成：
        </template>
        <template v-else-if="pendingCount > 0">
          您有 <b>{{ pendingCount }}</b> 项学习任务未完成，请尽快完成，避免打扰您使用系统：
        </template>
        <template v-else>
          您有待完成的学习任务，请尽快完成，避免打扰您使用系统：
        </template>
      </div>

      <!-- 课程列表 -->
      <div class="course-list">
        <div v-for="(item, index) in classes" :key="index" class="course-list__item">
          <a class="course-list__name" :href="item.classUrl" target="_blank" @click.stop>
            {{ item.className }}
          </a>
          <span class="course-list__countdown">
            {{ formatCountdown(item.countdownDays) }}
          </span>
        </div>
      </div>
    </div>

    <div slot="footer" class="course-popup-footer">
      <mtd-button v-if="!isForce" @click="handleLater">稍后学习</mtd-button>
      <mtd-button type="primary" @click="handleGoLearn">去学习</mtd-button>
    </div>
  </mtd-modal>
</template>

<script>
/* @source catpaw @line_count 277 @branch feature/ai-92575103-202604091027 */
import { pushLXModuleView, pushLXModuleClick } from '@/utils'
const STORAGE_KEY = 'ASSOCIATE_COURSE_POPUP_REMIND_DATE'

export default {
  name: 'CoursePopup',
  props: {
    // 弹窗数据，由父组件传入
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visible: false,
      popupData: {},
      cid: 'c_mobikeops_8fa4un26', // 复用全局弹窗cid
      routeGuard: null, // 路由守卫取消函数
    }
  },
  computed: {
    // 是否为强制弹窗（无"稍后学习"按钮）
    isForce() {
      return this.popupData.popupType === 'FORCE'
    },
    overdueCount() {
      return this.popupData.overdueCount || 0
    },
    pendingCount() {
      return this.popupData.pendingCount || 0
    },
    classes() {
      return this.popupData.classes || []
    },
  },
  methods: {
    /**
     * 展示弹窗
     * @param {Object} popupData - 弹窗数据
     * @param {string} popupData.popupType - 'NODE' | 'FORCE' | 'REMINDER'
     * @param {number} popupData.overdueCount - 已逾期课程数
     * @param {number} popupData.pendingCount - 即将到期课程数
     * @param {Array}  popupData.classes - 课程列表
     */
    show(popupData) {
      this.popupData = popupData || {}

      // 直接使用传入参数判断，不依赖 computed 属性（Vue 响应式更新是异步的，computed 可能还未更新）
      const isForce = popupData?.popupType === 'FORCE'
      pushLXModuleView('b_mobikeops_r2jm0xwy_mv', this.cid, {
        type: isForce ? 'FORCE' : 'REMINDER',
      })
      // 提醒弹窗需检查当天是否已展示过
      if (!isForce && this.hasShownToday()) {
        return false
      }

      // 提醒弹窗弹出时立即记录
      if (!isForce) {
        this.setShownToday()
      }

      this.visible = true
      return true
    },

    // 路由切换时专用：强制展示弹窗并注册路由守卫阻止跳转
    showForce(popupData) {
      this.popupData = popupData || {}
      pushLXModuleView('b_mobikeops_r2jm0xwy_mv', this.cid, { type: 'FORCE' })
      this.visible = true
      this.registerRouteGuard()
    },

    // 注册路由守卫，FORCE 弹窗展示期间禁止路由跳转
    registerRouteGuard() {
      if (this.routeGuard) return
      this.routeGuard = this.$router.beforeEach((to, from, next) => {
        // 已在课程中心，允许自由跳转并移除守卫
        if (from.path === '/daxue/course-center') {
          this.removeRouteGuard()
          next()
          return
        }
        // 允许跳转到课程中心页面
        if (to.path === '/daxue/course-center') {
          next()
        } else {
          next(false)
        }
      })
    },

    // 移除路由守卫
    removeRouteGuard() {
      if (this.routeGuard) {
        this.routeGuard()
        this.routeGuard = null
      }
    },

    // before-close 回调：FORCE 类型禁止关闭
    handleBeforeClose(done) {
      if (this.isForce) return
      done()
    },

    hide() {
      this.visible = false
      this.removeRouteGuard()
    },

    // 点击"稍后学习"
    handleLater() {
      pushLXModuleClick('b_mobikeops_nm2q2su0_mc', this.cid, window.__BIKE_POLARIS__.mis, {
        type: this.isForce ? 'FORCE' : 'REMINDER',
      })
      this.hide()
    },

    // 点击"去学习"
    handleGoLearn() {
      pushLXModuleClick('b_mobikeops_srr3kz24_mc', this.cid, window.__BIKE_POLARIS__.mis, {
        type: this.isForce ? 'FORCE' : 'REMINDER',
      })
      this.removeRouteGuard()
      this.hide()
      if (this.$route.path !== '/daxue/course-center') {
        this.$router.push({ path: '/daxue/course-center' })
      }
    },

    // 检查提醒弹窗当天是否已展示
    hasShownToday() {
      try {
        const storedDate = localStorage.getItem(STORAGE_KEY)
        const today = new Date().toDateString()
        return storedDate === today
      } catch (e) {
        return false
      }
    },

    // 格式化倒计时文本
    formatCountdown(days) {
      return days < 0 ? '倒计时0天' : '倒计时' + (days || '0') + '天'
    },

    // 记录当天已展示
    setShownToday() {
      try {
        const today = new Date().toDateString()
        localStorage.setItem(STORAGE_KEY, today)
      } catch (e) {
        // ignore
      }
    },
  },
}
</script>

<style lang="scss">
.course-popup-dialog {
  .mtd-modal {
    border-radius: 12px;
  }
  .mtd-modal-content-wrapper {
    padding: 20px 24px 0;
  }
  .course-popup-content {
    .course-popup-desc {
      font-size: 14px;
      color: #333;
      line-height: 22px;
      margin-bottom: 12px;

      b {
        color: #f5483b;
        font-weight: 600;
      }
    }
  }

  .course-list {
    max-height: 400px;
    overflow-y: auto;
    border: 1px solid #f0f0f0;
    border-radius: 6px;
    background: #fafafa;

    &__item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 14px;
      border-bottom: 1px solid #f0f0f0;
      gap: 12px;

      &:last-child {
        border-bottom: none;
      }
    }

    &__name {
      font-size: 14px;
      color: #1a7efb;
      text-decoration: none;
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:hover {
        text-decoration: underline;
      }
    }

    &__countdown {
      font-size: 13px;
      color: #1a7efb;
      white-space: nowrap;
      flex-shrink: 0;
    }
  }

  .course-popup-footer {
    display: flex;
    justify-content: center;
    gap: 12px;
  }
  // .mtd-modal-footer {
  //   padding: 16px 24px 24px;
  // }
}
</style>
